module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "size": "small"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "large-4 light-grey-button",
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    staticClass: "large-4 large-offset-2 alert",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("Confirmer")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77909985"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/confirm-modal.vue
// module id = 773
// module chunks = 0